(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ring-builder"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('ring-builder-app');
  if (!root || root.dataset.damasciFilterSheet) return;
  root.dataset.damasciFilterSheet = '1';
  const mobile = window.matchMedia('(max-width: 650px)');
  const backdrop = document.createElement('div');
  backdrop.className = 'damasci-filter-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  document.body.append(backdrop);
  let active = null;
  let frame = 0;
  const resultsButton = panel => panel.querySelector('.pc-mobile-show-results button');
  const opener = panel => panel.closest('.pc-responsive-p')?.querySelector('button.pc-setting-filter');
  const close = () => {
    if (!active) return;
    // Use the builder's own close action so its React state stays in sync.
    resultsButton(active)?.click();
  };
  const focusable = panel => [...panel.querySelectorAll('button, input, select, textarea, a[href], [tabindex="0"]')]
    .filter(node => !node.disabled && node.getClientRects().length);
  const attachHeader = panel => {
    if (panel.querySelector('.damasci-filter-sheet-header')) return;
    const header = document.createElement('div');
    header.className = 'damasci-filter-sheet-header';
    const title = document.createElement('h2');
    title.className = 'damasci-filter-sheet-title';
    title.textContent = 'Filters';
    const x = document.createElement('button');
    x.type = 'button';
    x.className = 'damasci-filter-sheet-close';
    x.setAttribute('aria-label', 'Close filters');
    x.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7"><path d="m6 6 12 12M18 6 6 18"/></svg>';
    x.addEventListener('click', close);
    header.append(title, x);
    panel.prepend(header);
    let drag = null;
    const clearDrag = () => {
      panel.style.removeProperty('--damasci-sheet-drag');
      panel.removeAttribute('data-dragging');
      drag = null;
    };
    header.addEventListener('pointerdown', event => {
      if (!mobile.matches || event.button !== 0 || event.target.closest('button')) return;
      drag = {id: event.pointerId, y: event.clientY, distance: 0};
      header.setPointerCapture(event.pointerId);
      panel.setAttribute('data-dragging', '');
    });
    header.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId) return;
      drag.distance = Math.max(0, event.clientY - drag.y);
      panel.style.setProperty('--damasci-sheet-drag', `${drag.distance}px`);
    });
    header.addEventListener('pointerup', event => {
      if (!drag || drag.id !== event.pointerId) return;
      const dismiss = drag.distance >= Math.min(100, panel.clientHeight * 0.18);
      clearDrag();
      if (dismiss) close();
    });
    header.addEventListener('pointercancel', clearDrag);
    header.addEventListener('lostpointercapture', clearDrag);
  };
  const sync = () => {
    frame = 0;
    let next = null;
    root.querySelectorAll('.pc_setting_listing:has(.sp-diamondt-links) .pc-filter-grids').forEach(panel => {
      attachHeader(panel);
      if (!panel.classList.contains('damasci-filter-sheet')) panel.classList.add('damasci-filter-sheet');
      const button = resultsButton(panel);
      if (button && button.textContent.trim() === 'Show Results') button.textContent = 'View Results';
      if (mobile.matches && panel.classList.contains('pc-mobile-show-filter-section')) next = panel;
    });
    if (next === active) return;
    const previous = active;
    active = next;
    if (previous) {
      previous.removeAttribute('role');
      previous.removeAttribute('aria-modal');
      previous.removeAttribute('aria-label');
      previous.style.removeProperty('--damasci-sheet-drag');
      previous.removeAttribute('data-dragging');
    }
    backdrop.classList.toggle('is-open', !!active);
    document.body.classList.toggle('damasci-filter-sheet-active', !!active);
    if (active) {
      active.setAttribute('role', 'dialog');
      active.setAttribute('aria-modal', 'true');
      active.setAttribute('aria-label', 'Diamond filters');
      active.querySelector('.damasci-filter-sheet-close')?.focus({preventScroll:true});
    } else if (previous?.isConnected && mobile.matches) {
      opener(previous)?.focus({preventScroll:true});
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  new MutationObserver(schedule).observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  backdrop.addEventListener('click', close);
  mobile.addEventListener('change', schedule);
  document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      const nodes = focusable(active);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !active.contains(document.activeElement))) {
        event.preventDefault(); first?.focus();
      }
    }
  });
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
